<div>
  <div class="header-leads">
    <div>
      <h5 class="text-center header-leads-text">
        {{leadData.escopo}}
      </h5>
    </div>
      <div class="p-d-flex p-jc-between p-ai-center p-flex-wrap p-px-2 p-py-1">
      <span class="header-leads-text">Leads</span>
      <span class="header-leads-text">{{ leadData.totalLeads }}</span>
    </div>
  </div>
  <div *ngFor="let categoria of leadData.categorias">
    <app-resumo-leads-grid [leadCategoria]="categoria"></app-resumo-leads-grid>
  </div>

  <div class="p-mt-2 header-categoria">
    <div class="p-grid header-categoria-titulo">
      <div class="p-col-8 p-sm-10 p-md-10 p-lg-10 p-p-1">
        <p class="header-categoria-text p-m-0" ngClass="texto-vermelho">
          Insucesso (só nos qualificados)
        </p>
      </div>
      <div class="p-col-4 p-sm-2 p-md-2 p-lg-2 p-d-flex p-jc-center p-p-1">
        <p class="header-categoria-text text-center p-m-0" ngClass="texto-vermelho">
          {{totalInsucesso}}
        </p>
      </div>
    </div>
    <div *ngFor="let item of insucessoLeads" class="p-grid">
      <div class="p-col-8 p-sm-10 p-md-10 p-lg-10 p-pr-0 p-pt-0 p-pb-0 p-pl-1 div-item-descricao">
        <span class="lead-item-descricao">{{item.label}}</span>
      </div>
      <div class="p-col-4 p-sm-2 p-md-2 p-lg-2 p-d-flex p-jc-center p-ai-center p-pr-1 p-pt-0 p-pb-0 p-pl-1 div-item-quantidade">
        <span class="lead-item-quantidade text-center">{{item.valor}}</span>
      </div>
    </div>
  </div>
</div>
